import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const PageContainer = styled(Box)(({ theme }) => ({
  minHeight: "100vh",
  backgroundColor: theme.palette.background.secondary,
  padding: "60px 20px",
}));

export const ContentBox = styled(Box)(() => ({
  maxWidth: "900px",
  margin: "0 auto",
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: "32px",
  fontWeight: 700,
  color: theme.palette.primary.main,
  marginBottom: "16px",
  fontFamily: "Nunito",
}));

export const LastUpdated = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 400,
  color: theme.palette.text.secondary,
  marginBottom: "32px",
  fontFamily: "Nunito",
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: "20px",
  fontWeight: 700,
  color: theme.palette.primary.main,
  marginTop: "32px",
  marginBottom: "16px",
  fontFamily: "Nunito",
}));

export const Paragraph = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 400,
  color: theme.palette.text.primary,
  lineHeight: "1.6",
  marginBottom: "16px",
  fontFamily: "Nunito",
  textAlign: "justify",
}));
